module.exports = __webpack_public_path__ + "static/media/prep.38f33d6b.png";